import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import RoutePrivate from 'components/RoutePrivate'
import RouteWithAuth from 'components/RouteWithAuth'
import paths from 'constants/paths'
import Account from 'views/Account'
import NotFound from 'views/NotFound'
import PasswordChange from 'views/PasswordChange'
import PasswordReset from 'views/PasswordReset'
import Report from 'views/Report'
import ReportEdit from 'views/ReportEdit'
import Reports from 'views/Reports'
import SignIn from 'views/SignIn'
import SignUp from 'views/SignUp'

export default function Routes() {
  return (
    <Switch>
      <Redirect path={paths.HOME} to={paths.REPORTS} exact />
      <RoutePrivate path={paths.ACCOUNT} component={Account} />
      <Route path={paths.PASSWORD_CHANGE} component={PasswordChange} />
      <Route path={paths.PASSWORD_RESET} component={PasswordReset} />
      <RoutePrivate path={paths.REPORTS} exact component={Reports} />
      <RoutePrivate path={`${paths.REPORTS}/:id/edit`} component={ReportEdit} />
      <RouteWithAuth path={`${paths.REPORTS}/:id`} component={Report} />
      <Route path={paths.SIGN_UP} component={SignUp} />
      <Route path={paths.SIGN_IN} component={SignIn} />
      {/*<Redirect path={paths.SIGN_IN} to={paths.REPORTS} />*/}
      <Route component={NotFound} />
    </Switch>
  )
}


// WEBPACK FOOTER //
// ./src/components/App/Routes.js